import React from "react";

import { FormTasksView } from "components/FormTasksView";

const ProposalTasksView = () => {
	return (
		<FormTasksView />
	);
};

export default ProposalTasksView;
